/* eslint-disable local-rules/require-use-client */
import { Listbox, ListboxButton, ListboxOption, ListboxOptions } from '@headlessui/react'
import { CheckIcon, ChevronUpDownIcon } from '@heroicons/react/20/solid'

import { cn } from '@src/utils/tailwind'

import type { SKUDropdownOption } from './SKUSelectorProps'

export interface SKUSelectorDropdownProps {
  dropdownOptions: SKUDropdownOption[] | undefined
  activeOption: SKUDropdownOption | undefined
  selectedSku: string
  isLoading: boolean
  onChange: (sku: string) => void
}

export function SKUSelectorDropdown({
  dropdownOptions,
  activeOption,
  selectedSku,
  isLoading,
  onChange,
}: SKUSelectorDropdownProps) {
  return (
    <Listbox value={selectedSku} onChange={onChange} disabled={isLoading}>
      <ListboxButton className="flex items-center justify-between rounded-lg p-4 text-left outline outline-1 outline-bodi-gray-butters">
        {activeOption?.label}
        <ChevronUpDownIcon className="size-4" />
      </ListboxButton>
      <ListboxOptions
        anchor="bottom"
        transition
        className={cn(
          'mt-2 w-(--button-width) origin-top rounded-lg bg-bodi-white py-2 outline outline-1 outline-bodi-gray-butters drop-shadow-md',
          'transition duration-200 ease-out data-closed:scale-95 data-closed:opacity-0'
        )}
      >
        {dropdownOptions?.map((option) => (
          <ListboxOption
            key={option.sku}
            value={option.sku}
            className="flex items-center gap-2 p-3 text-left hover:bg-bodi-green-bright-300"
          >
            <CheckIcon
              className={cn(
                'size-5 text-transparent',
                option.sku === selectedSku && 'text-bodi-green-deep-500'
              )}
            />
            {option.label}
          </ListboxOption>
        ))}
      </ListboxOptions>
    </Listbox>
  )
}
